import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Environment } from '../../config/environment';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(private http: HttpClient, private Conf: Config) { }

  public getExecutions(name: string) {
    let httpOptions: any = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: new HttpParams().set('name', name)
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'scheduler/executions';

    return this.http.get(url, httpOptions);
  }

  public updateScheduler(name: string, cronExpression: string) {
    let httpOptions: any = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: new HttpParams()
        .set('name', name)
        .set('cronExpression', cronExpression)
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'scheduler/update';

    return this.http.put(url, null, httpOptions);
  }

  public getObservaciones() {
    let httpOptions: any = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'scheduler/observaciones';

    return this.http.get(url, httpOptions);
  }

  public getConstantsByCodigos(codigos: string[]) {
    let httpOptions: any = {
      withCredentials: false,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    if (Environment.CREDENTIALS) {
      httpOptions.withCredentials = true;
    }

    let url = this.Conf.ENDPOINT_API + 'getConstantsByCodigos';

    return this.http.post(url, codigos, httpOptions);
  }
}
